import { useSelector, useDispatch } from 'react-redux';
import { getTemplates } from '../redux/actions/whatsApp'; 
import { useEffect } from 'react';
import { useDataAuth } from "./useDataAuth"; 

export const useWhatsApp = () => {
  const dispatch = useDispatch();
  
  const { templates } = useSelector(state => state.whatsApp);
  const [{ userSession }] = useDataAuth();

  useEffect(() => {
    dispatch(getTemplates(userSession.token));
  }, [dispatch, userSession]);

  return [{ templates }];
};
